module.exports = __webpack_public_path__ + "img/zhuanjingtexin.5d540259.png";